import { CurrencyEnum } from '@ark/utils';

/**
 * 格式化奖励金额展示
 *
 * @param currency 币种
 * @param amount 金额
 */
export function formatRewardAmount(currency: string, amount: number): string {
  const symbol = getCurrencySymbol(currency);
  return currency === 'JPY' ? `${amount}${symbol}` : `${symbol}${amount}`;
}

function getCurrencySymbol(currency: string): string {
  switch (currency) {
    case CurrencyEnum.KV.HKD:
      return 'HK$ ';
    case CurrencyEnum.KV.SGD:
      return 'S$ ';
    case CurrencyEnum.KV.MYR:
      return 'RM';
    case CurrencyEnum.KV.JPY:
      return '円';
    case CurrencyEnum.KV.AUD:
    case CurrencyEnum.KV.CAD:
    case CurrencyEnum.KV.USD:
      return '$';
    default:
      return `${currency} `;
  }
}
